import script from "./ProgramsDashboardSidebarFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramsDashboardSidebarFilter.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramsDashboardSidebarFilter.vue?vue&type=style&index=0&id=14497a84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14497a84"]])

export default __exports__